var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path5, _path6, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path7, _path8, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path9, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _rect, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 148,
    viewBox: "0 0 268 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5731 40.3C32.5762 46.5941 35.4264 61.6217 41.7205 62.6186C48.0145 63.6155 55.369 50.2041 56.3659 43.9101C57.3628 37.616 53.0686 31.7055 46.7745 30.7087C40.4804 29.7118 34.57 34.006 33.5731 40.3Z",
    fill: "#004092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7186 43.3323C51.7217 49.6263 54.5719 64.6539 60.866 65.6508C67.16 66.6477 74.5145 53.2364 75.5114 46.9423C76.5083 40.6482 72.2141 34.7378 65.92 33.7409C59.6259 32.744 53.7155 37.0382 52.7186 43.3323Z",
    fill: "#539EFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.61538,
    cy: 4.61538,
    r: 4.61538,
    transform: "matrix(-0.987688 -0.156434 -0.156434 0.987688 50.25 38.2686)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.61538,
    cy: 4.61538,
    r: 4.61538,
    transform: "matrix(-0.987688 -0.156434 -0.156434 0.987688 69.3965 41.3008)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.142,
    cy: 66.2655,
    r: 1.84615,
    transform: "rotate(9 41.142 66.2655)",
    fill: "#004092"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5239,
    cy: 67.2763,
    r: 1.84615,
    transform: "rotate(9 47.5239 67.2763)",
    fill: "#004092"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9057,
    cy: 68.287,
    r: 1.84615,
    transform: "rotate(9 53.9057 68.287)",
    fill: "#004092"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.2876,
    cy: 69.2978,
    r: 1.84615,
    transform: "rotate(9 60.2876 69.2978)",
    fill: "#004092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.079 44.9238C132.004 55.5042 142.673 78.6571 153.253 77.7314C163.834 76.8057 170.32 52.1521 169.394 41.5717C168.468 30.9912 159.141 23.1645 148.56 24.0901C137.98 25.0158 130.153 34.3434 131.079 44.9238Z",
    fill: "#004092"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.263 42.1074C164.189 52.6878 174.857 75.8406 185.438 74.915C196.018 73.9893 202.504 49.3357 201.578 38.7552C200.653 28.1748 191.325 20.3481 180.745 21.2737C170.164 22.1994 162.338 31.5269 163.263 42.1074Z",
    fill: "#539EFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.69231,
    cy: 7.69231,
    r: 7.69231,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 157.23 34.9131)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.69231,
    cy: 7.69231,
    r: 7.69231,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 189.415 32.0977)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.789,
    cy: 83.8615,
    r: 3.07692,
    transform: "rotate(-5 153.789 83.8615)",
    fill: "#004092"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.517,
    cy: 82.923,
    r: 3.07692,
    transform: "rotate(-5 164.517 82.923)",
    fill: "#004092"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.246,
    cy: 81.9845,
    r: 3.07692,
    transform: "rotate(-5 175.246 81.9845)",
    fill: "#004092"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.974,
    cy: 81.0461,
    r: 3.07692,
    transform: "rotate(-5 185.974 81.0461)",
    fill: "#004092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7396 20.0995C78.221 27.516 83.0616 44.6917 90.4781 45.2103C97.8946 45.7289 105.078 29.3941 105.597 21.9776C106.116 14.5611 100.524 8.12841 93.1074 7.6098C85.6909 7.09119 79.2582 12.683 78.7396 20.0995Z",
    fill: "#004092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.3 21.6776C100.782 29.0941 105.622 46.2698 113.039 46.7884C120.455 47.307 127.639 30.9722 128.158 23.5557C128.676 16.1392 123.084 9.70654 115.668 9.18792C108.251 8.66931 101.819 14.2611 101.3 21.6776Z",
    fill: "#539EFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.38462,
    cy: 5.38462,
    r: 5.38462,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 97.916 16.042)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.38462,
    cy: 5.38462,
    r: 5.38462,
    transform: "matrix(-0.997564 -0.0697565 -0.0697565 0.997564 120.477 17.6201)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.178,
    cy: 49.5078,
    r: 2.15385,
    transform: "rotate(4 90.178 49.5078)",
    fill: "#004092"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.6985,
    cy: 50.0332,
    r: 2.15385,
    transform: "rotate(4 97.6985 50.0332)",
    fill: "#004092"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.218,
    cy: 50.5596,
    r: 2.15385,
    transform: "rotate(4 105.218 50.5596)",
    fill: "#004092"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.739,
    cy: 51.085,
    r: 2.15385,
    transform: "rotate(4 112.739 51.085)",
    fill: "#004092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7755 80.9308C74.6106 90.4184 79.67 112.797 89.1575 113.962C98.6451 115.127 108.968 94.6369 110.133 85.1494C111.298 75.6619 104.551 67.0263 95.0635 65.8614C85.576 64.6965 76.9405 71.4433 75.7755 80.9308Z",
    fill: "#004092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.636 84.4738C103.471 93.9613 108.53 116.34 118.018 117.505C127.505 118.67 137.828 98.1799 138.993 88.6924C140.158 79.2048 133.411 70.5693 123.924 69.4044C114.436 68.2395 105.801 74.9863 104.636 84.4738Z",
    fill: "#539EFF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-0.992546 -0.121869 -0.121869 0.992546 100.671 77.0117)",
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.92308,
    cy: 6.92308,
    r: 6.92308,
    transform: "matrix(-0.992546 -0.121869 -0.121869 0.992546 129.531 80.5557)",
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.4824,
    cy: 119.459,
    r: 2.76923,
    transform: "rotate(7 88.4824 119.459)",
    fill: "#004092"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.1025,
    cy: 120.641,
    r: 2.76923,
    transform: "rotate(7 98.1025 120.641)",
    fill: "#004092"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.723,
    cy: 121.821,
    r: 2.76923,
    transform: "rotate(7 107.723 121.821)",
    fill: "#004092"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.343,
    cy: 123.003,
    r: 2.76923,
    transform: "rotate(7 117.343 123.003)",
    fill: "#004092"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 90C47 88.8954 47.8954 88 49 88H69.2654C70.2607 88 71.1046 88.7319 71.2453 89.7172L74.7547 114.283C74.8954 115.268 75.7393 116 76.7346 116H177.265C178.261 116 179.105 115.268 179.245 114.283L182.755 89.7172C182.895 88.7319 183.739 88 184.735 88H205C206.105 88 207 88.8954 207 90V116V142C207 143.105 206.105 144 205 144H175H79H49C47.8954 144 47 143.105 47 142V116V90Z",
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 43.5,
    r: 1.5,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 57.5,
    r: 1.5,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 120.5,
    r: 1.5,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 19 148)",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M219 75L237 80",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10L32 15",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 76L19 74",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216 21L234 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveDistance);
export default __webpack_public_path__ + "static/media/collective-distance.e3f2484b451c590cfe17e504016f3c5d.svg";
export { ForwardRef as ReactComponent };